import Rest from '@/services/Rest';

/**
 * @typedef {AddressService}
 */
export default class AddressService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/address-product'
}